import moment from 'moment-timezone'
import { I24, II24, I25, II25, I26, II26, I27, II27 } from '../constants/service'

export const tj = (startDate: Date, duration: number): number => {
  const today = moment().tz('Europe/Helsinki')
  const start = moment(startDate).tz('Europe/Helsinki')
  const diff = today.diff(start, 'days')
  let remaining = duration - diff - 1 // last day, "TJ0", is not included
  remaining = remaining < duration ? remaining : duration
  return remaining > 0 ? remaining : 0
}

export const getFinalDay = (startDate: Date, duration: number) =>
  moment(startDate)
    .tz('Europe/Helsinki')
    .add(duration - 1, 'days') // last day, "TJ0", is not included
    .toDate()

export const getClosestPresetDate = (): Date => {
  const today = moment().tz('Europe/Helsinki')
  const presets = [I24, II24, I25, II25, I26, II26, I27, II27]

  let closest = presets[0]
  let minDiff = Math.abs(today.diff(moment(presets[0]).tz('Europe/Helsinki'), 'days'))

  for (const preset of presets) {
    const diff = Math.abs(today.diff(moment(preset).tz('Europe/Helsinki'), 'days'))
    if (diff < minDiff) {
      minDiff = diff
      closest = preset
    }
  }

  return closest
}
